var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSplitPay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12441_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.65 23.77H3.35C1.5 23.77 0 22.27 0 20.42V3.57998C0 1.72998 1.5 0.22998 3.35 0.22998H28.65C30.5 0.22998 32 1.72998 32 3.57998V20.42C32 22.27 30.5 23.77 28.65 23.77ZM3.35 1.87998C2.41 1.87998 1.65 2.64998 1.65 3.58998V20.43C1.65 21.37 2.41 22.13 3.35 22.13H28.65C29.59 22.13 30.35 21.37 30.35 20.43V3.57998C30.35 2.63998 29.59 1.86998 28.65 1.86998H3.35V1.87998Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1801 18.81V19.86H24.3801V18.79C23.0601 18.6 22.2001 17.66 22.2201 16.54H23.6401C23.6401 17.14 24.1201 17.64 24.9301 17.64C25.6601 17.64 26.0801 17.2 26.0801 16.67C26.0801 16.26 25.8001 15.91 25.0901 15.72L24.1801 15.46C22.5601 15.05 22.2801 14.08 22.2801 13.45C22.2801 12.3 23.2001 11.48 24.4001 11.31V10.28H25.2001V11.31C26.4501 11.45 27.3001 12.33 27.2901 13.53H25.8601C25.8701 12.93 25.4501 12.5 24.8101 12.5C24.1701 12.5 23.7201 12.89 23.7201 13.41C23.7201 13.62 23.7801 14.04 24.5701 14.25L25.4301 14.47C26.6201 14.79 27.5101 15.44 27.5101 16.59C27.5101 17.84 26.5101 18.7 25.1901 18.8L25.1801 18.81Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6099 13.25H4.90991V14.9H13.6099V13.25Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80991 16.53H4.90991V18.17H9.80991V16.53Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62991 4.90991H5.53991C5.19197 4.90991 4.90991 5.19197 4.90991 5.53991V8.62991C4.90991 8.97785 5.19197 9.25991 5.53991 9.25991H8.62991C8.97785 9.25991 9.25991 8.97785 9.25991 8.62991V5.53991C9.25991 5.19197 8.97785 4.90991 8.62991 4.90991Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1137 0.432013L2.81519 22.3308L3.88853 23.5708L29.187 1.67199L28.1137 0.432013Z",
    fill: "#1D2939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12441_208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSplitPay);
export default __webpack_public_path__ + "static/media/IconSplitPay.a7c96cb1.svg";
export { ForwardRef as ReactComponent };